import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { format } from 'date-fns';
import { ModalService } from 'src/app/services/modal.service';
import { setLoadingSpinner } from 'src/app/store/actions/shared.action';
import { updateApplicationStatus } from 'src/app/store/actions/student.action';

@Component({
  selector: 'app-update-application-status',
  templateUrl: './update-application-status.component.html',
  styleUrls: ['./update-application-status.component.scss']
})
export class UpdateApplicationStatusComponent implements OnInit {

  application!: any
  schoolYearId!: any

  form: FormGroup

  interviewDateRequired = false;
  interviewTimeRequired = false;

  constructor(
    private fb: FormBuilder,
    private store: Store,
    private modalService: ModalService
  ) { }

  ngOnInit(): void {
    console.log(this.application);
    this.form = this.fb.group({
      status: ['', [Validators.required]],
      remarks: ['', new FormControl()],
      interviewDate: ['', new FormControl()],
      interviewTime:  ['', new FormControl()],
    });

    this.form.patchValue({
      status: this.application?.notes[this.application?.notes?.length - 1]?.status,
      remarks: this.application?.notes[this.application?.notes?.length - 1]?.remarks,
      interviewDate: this.formatDate(this.application?.notes[this.application?.notes?.length - 1]?.date_interview),
      interviewTime: this.formatTime(this.application?.notes[this.application?.notes?.length - 1]?.date_interview),
    });

    console.log(this.schoolYearId);
  }

  toggleDateAndTimeValidation(){
    this.resetValue();
    if(this.status?.value == 'first_interview_scheduled' || this.status?.value == 'second_interview_scheduled'){
      this.interviewDateRequired = true;
      this.interviewTimeRequired = true;
      this.setRequiredField('interviewDate');
      this.setRequiredField('interviewTime');
    } else{
      this.removeFieldValidation('interviewDate')
      this.removeFieldValidation('interviewTime');
    }
  }

  setRequiredField(field: string) {
    this.form.addControl(field, new FormControl());
    this.form.controls[field]?.setValidators([Validators.required]);
    this.form.controls[field]?.updateValueAndValidity();
  }

  removeFieldValidation(field: any){
    this.form.get(field)?.setValidators(null);
    this.form.get(field)?.updateValueAndValidity();
  }

  update(){
    let dateInterview;
    if(this.interviewDate?.value && this.interviewTime?.value){
      dateInterview = this.formatDate(this.interviewDate?.value)+'T'+this.convertTo24HourWithSeconds(this.interviewTime?.value)
    } else{
      dateInterview = '';
    }
    const payload = {
      status: this.status?.value,
      remarks: this.remarks?.value,
      date_interview: dateInterview 
    }

    console.log(payload);
    this.store.dispatch(setLoadingSpinner({status: true}));
    this.store.dispatch(updateApplicationStatus({applicationId: this.application?.id, data: payload, schoolYearId: this.schoolYearId?.id}));
  }

  convertTo24HourWithSeconds(time12h: string): string {
    const [time, modifier] = time12h.trim().split(' ');
    let [hours, minutes] = time.split(':').map(Number);
  
    if (modifier.toUpperCase() === 'AM' && hours === 12) {
      hours = 0;
    } else if (modifier.toUpperCase() === 'PM' && hours !== 12) {
      hours += 12;
    }
  
    const formatted = [
      String(hours).padStart(2, '0'),
      String(minutes).padStart(2, '0'),
      '00', // seconds
    ];
  
    return formatted.join(':');
  }

  formatDate(date){
    if(date){
      return format(new Date(date), 'yyyy-MM-dd');
    }
    return
  }

  formatTime(date){
     if(date){
      return format(new Date(date), 'h:mm a');
    }
    return
  }

  cancel(){
    this.modalService.hideUpdateApplicationStatus();
  }

  get status(){
    return this.form.get('status');
  }

  get remarks(){
    return this.form.get('remarks');
  }

  get interviewDate(){
    return this.form.get('interviewDate');
  }

  get interviewTime(){
    return this.form.get('interviewTime');
  }

  resetValue(){
    this.form.patchValue({
      remarks: '',
      interviewDate: '',
      interviewTime: '',
    });
  }
}
